// Action Types
const SET_PHONE = "auth/SET_PHONE";
const SET_AUTH = "auth/SET_AUTH";
const SET_OTP = "auth/SET_OTP";
const SET_AGE_RANGE = "auth/SET_AGE_RANGE";
const RESET_AUTH = "auth/RESET_AUTH";
const SET_ACTIVE_SECTION = "auth/SET_ACTIVE_SECTION";

// Initial State
const initialState = {
  isLogged: false,
  phoneNumber: "",
  otpCode: "",
  ageRange: "",
  activeSection: 0,
};

// Action Creators
export const setPhone = (phoneNumber) => ({
  type: SET_PHONE,
  payload: phoneNumber,
});

export const setAuth = (isLogged) => ({
  type: SET_AUTH,
  payload: isLogged,
});

export const setOTP = (otpCode) => ({
  type: SET_OTP,
  payload: otpCode,
});

export const setAgeRange = (ageRange) => ({
  type: SET_AGE_RANGE,
  payload: ageRange,
});

export const resetAuth = () => ({
  type: RESET_AUTH,
});

export const setActiveSeciton = (activeSection) => ({
  type: SET_ACTIVE_SECTION,
  payload: activeSection,
});

// Reducer
export const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_PHONE:
      return {
        ...state,
        phoneNumber: action.payload,
      };
    case SET_AUTH:
      return {
        ...state,
        isLogged: action.payload,
      };
    case SET_OTP:
      return {
        ...state,
        otpCode: action.payload,
      };
    case SET_AGE_RANGE:
      return {
        ...state,
        ageRange: action.payload,
      };
    case RESET_AUTH:
      return initialState;
    case SET_ACTIVE_SECTION:
      return {
        ...state,
        activeSection: action.payload,
      };
    default:
      return state;
  }
};
